import { apiClient } from "@/lib/api/client"
import type { BlankStatus, BlanksPageResult, BlankType, Sort } from "shared"

export type { BlankStatus, BlanksPageResult, BlankType, OtkBlank } from "shared"

// otk-be's `GET /otk/blanks` (`otk-blanks.ts`/`otkBlanksListQuerySchema`) —
// one status per request (not the repeatable set warehouse.md's own
// idealized `GET /api/otk/spetsproduktsiya` assumed), cursor-paginated,
// subject-scoped server-side from the authenticated user (no `punktId`
// param exists yet — see `lib/warehouse.ts`'s note on the missing пункт
// field). Same "one request per tab" shape `getOtkDocumentsPage` already
// uses for documents.
export async function getOtkBlanksPage({
  cursor,
  pageSize = 25,
  sort = "ASC",
  status,
  type,
}: {
  cursor?: string
  pageSize?: number
  sort?: Sort
  status: BlankStatus
  type?: BlankType
}): Promise<BlanksPageResult> {
  const { data } = await apiClient.get<BlanksPageResult>("/otk/blanks", {
    params: { cursor, pageSize, sort, status, type },
  })
  return data
}
